import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Certificate Download")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Registration Number", -1)
const _hoisted_11 = { class: "col-md-2 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "border-top pt-9"
}
const _hoisted_14 = {
  key: 0,
  id: "trainee_profile"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { class: "profile-info pt-1 pb-1" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-3" }
const _hoisted_19 = { class: "thumbnail" }
const _hoisted_20 = {
  href: "javascript:;",
  class: "",
  title: "Entity Logo"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "col-sm-9" }
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Registration Number")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reference Number")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Name")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gender")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Father Name")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mother Name")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "National ID")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Birth Certificate Number")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date of Birth")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Home District")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Present Address")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent Address")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mobile")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Alternative Mobile")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Religion")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Highest Class Completed")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Attendance Percentage ")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_44 = {
  key: 1,
  class: "text-center"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h4", null, "No data found!", -1)
const _hoisted_46 = [
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.registration_number) = $event)),
                    placeholder: "Search"
                  }, null, 512), [
                    [_vModelText, _ctx.trainee.registration_number]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getTraineeInfo())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_12
                ])
              ])
            ]),
            (_ctx.showTraineeInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.traineeInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_router_link, {
                          style: {"float":"right"},
                          class: "btn btn-primary d-flex justify-content-end btn btn-sm btn-success",
                          to: `training-certificate-view/${_ctx.traineeInfo?.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Download Certificate ")
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createElementVNode("h2", null, "Profile of " + _toDisplayString(_ctx.traineeInfo.trainee_name), 1),
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("a", _hoisted_20, [
                                  _createElementVNode("img", {
                                    class: "d-flex justify-content-center h-100 w-100",
                                    src: _ctx.traineeInfo?.attach_file_info
                                                        ? _ctx.api_url +
                                                        _ctx.traineeInfo?.attach_file_info?.file_path
                                                        : 'media/avatars/blank.png'
                                                        ,
                                    alt: ""
                                  }, null, 8, _hoisted_21)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("table", _hoisted_24, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_25,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.registration_number), 1),
                                      _hoisted_26,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.reference_number), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_27,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.trainee_name), 1),
                                      _hoisted_28,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.gender), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_29,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.father_name), 1),
                                      _hoisted_30,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.mother_name), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_31,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.nid), 1),
                                      _hoisted_32,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.bcn), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_33,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.moment(_ctx.traineeInfo.date_of_birth).format(
                                                                        'DD-MM-YYYY'
                                                                    )), 1),
                                      _hoisted_34,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo.home_district_info
                                                                        .district_name_eng), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_35,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.present_address), 1),
                                      _hoisted_36,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.per_address), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_37,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.mobile), 1),
                                      _hoisted_38,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.alternative_mobile), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_39,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.email), 1),
                                      _hoisted_40,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.religion), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_41,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo.highest_class_completed), 1),
                                      _hoisted_42,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.attendance_percentage), 1)
                                    ]),
                                    _hoisted_43
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}